import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

/**
 * The select this product uses. The prototype's Radix Select is not ported: it locks page scroll through
 * react-remove-scroll, which writes a `<style>` element at runtime, and production's `style-src 'self'`
 * refuses it (apps/api/src/platform/security.ts). A native `<select>` also keeps the phone's own picker.
 *
 * It wears Input's recipe (the prototype's input: `h-11` for the touch floor, 36 px under a fine pointer), so a select and a text field
 * side by side in a form share border, fill, shadow, radius, type size and focus ring. The chevron and the
 * right padding that clears it come from the `select` rule in globals.css.
 */
function NativeSelect({ className, ...props }: ComponentProps<'select'>) {
  return (
    <select
      data-slot="native-select"
      className={cn(
        'h-11 pointer-fine:h-9 w-full min-w-0 rounded-md border border-input bg-background pl-3 text-sm shadow-sm transition-colors focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
        'aria-invalid:border-destructive',
        className,
      )}
      {...props}
    />
  );
}

export { NativeSelect };
